import { send as setAlert } from "./alert";
import api from "../utils/api";
import { isFalseOrEmpty } from '../utils/string';
import { safeTokenizeRedirect } from "../utils/tenant-domain";

import {
  AUTH_ERROR,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  LOGOUT,
  USER_LOADED,
  PASSWORD_CHANGE,
  RESET_SUCCESS,
  RESET_FAILED,
  VERIFY_TOKEN_FAILED,
  VERIFY_TOKEN_SUCCESS
} from "./types";

function tokenizeRedirectUrl({ destination, expectedDestination, instance, args = "", token, next = null }) {
  return safeTokenizeRedirect({ destination, expectedDestination, instance, args, token, next });
}

export const permitted = (name) => async (dispatch) => {
  try {
    const res_permitted = await api.get(`/users/me/permitted/n/${name}`);
    return res_permitted?.status === 200;
  } catch (error) {
    return false;
  }
}

export const loadUser = () => async (dispatch) => {
  try {
    const res = await api.get("/users/me");
    const res_permitted = await api.get("/users/me/permitted/n/CAN.LOGIN");
    if (res_permitted.status !== 200) throw new Error(res_permitted?.data?.msg);
    dispatch({
      type: USER_LOADED,
      payload: res.data,
    });

  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

export const login = ({instance, email, password, destination: expectedDestination, args="", url=null, token=null}) => async (dispatch) => {
  try {
    const res = await api.post("/auth/local", { instance, email, password, token });
    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    const status = err?.response?.status || err?.status;
    const message = err?.response?.data?.error?.message || {};

    if (status === 308 && message.destination && message.token && instance) {
      const redirect = tokenizeRedirectUrl({
        destination: message.destination,
        expectedDestination,
        instance,
        args: isFalseOrEmpty(args) ? "" : args,
        token: message.token,
        next: url
      });
      if (!redirect) {
        dispatch(setAlert("The sign-in destination is not an approved tenant domain.", "error"));
        dispatch({ type: LOGIN_FAILED });
        return;
      }
      window.location.href = redirect;
      return;
    }

    const errors = err?.response?.data?.errors;
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "error")));
    }

    dispatch({
      type: LOGIN_FAILED,
    });
  }
};

export const logout = () => ({ type: LOGOUT });

export const changePassword = (userId, passwords) => async (dispatch) => {
  try {
    const res = await api.post(`/users/${userId}/password/change`, passwords);
    dispatch({
      type: PASSWORD_CHANGE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};


export const verifyToken = (token, email) => async (dispatch) => {
  try {
    const res = await api.post(`/auth/verify/token`, { email, token });
    dispatch({
      type: VERIFY_TOKEN_SUCCESS,
      payload: {
        uuid: res.data.uuid
      }
    });
    return { uuid: res.data.uuid, success: true };

  } catch (err) {
    dispatch({
      type: VERIFY_TOKEN_FAILED,
      payload: {
        email,
        token,
        msg: err?.response?.statusText,
        status: err?.response?.status
      }
    });
  };
  return { uuid: null, success: false };
};

export const resetByToken = (token, instance, email, passwords) => async (dispatch) => {
  try {
    await api.post(`/auth/change`, { instance, token, email, password: passwords });
    dispatch({
      type: RESET_SUCCESS,
      payload: {
        email
      }
    });
    return {
      success: true,
      email
    };
  } catch (err) {
    dispatch({
      type: RESET_FAILED,
      payload: {
        email,
        token,
        msg: err?.response?.statusText,
        status: err?.response?.status
      }
    });
  };

  return {
    success: false,
    email
  };
  
};


export const sendReset = ({instance, email}) => async (dispatch) => {
  try {
    const response = await api.post("/auth/reset", { instance, email });
    return {
      ...response.data,
      success: response.data?.success === true
    };
                
  } catch (err) {
    const errors = err?.response?.data?.errors || err?.response?.data?.error?.errors;
    const apiMessage =
      errors?.[0]?.msg ||
      err?.response?.data?.error?.message;
    const status = Number(err?.response?.status || err?.response?.data?.error?.status);
    const fallback = "We couldn't send a reset email. Confirm the address and try again.";
    const message =
      !apiMessage ||
      status >= 500 ||
      apiMessage === "Invalid credentials"
        ? fallback
        : apiMessage;

    return { success: false, message };
  }
}

export const preChallenge = ({ email }) => async (dispatch, getState) => {
  try {
    const __response = await api.post("/auth/challenge/pre", { email });
    return { ...__response.data, success: true };
  } catch (err) {
    const errors = err?.response?.data?.errors;
    if (errors) errors.forEach((error) => dispatch(setAlert(error.msg, "error")));
    return { success: false };
  }
};


export const sendChallenge = ({ email, phone, channel }) => async (dispatch, getState) => {
  try {
    const __response = await api.post("/auth/challenge/send", { email, phone, channel });
    return { ...__response.data, success: true };

  } catch (err) {
    const errors = err?.response?.data?.errors;
    if (errors) errors.forEach((error) => dispatch(setAlert(error.msg, "error")));
    return { success: false };
  }
};


export const verifyChallenge = ({ token, code }) => async (dispatch) => {
  try {
    const _response = await api.post("/auth/challenge/verify", { token, code });
    return { ..._response.data, success: true };
  } catch (err) {
    const errors = err?.response?.data?.errors;
    if (errors) errors.forEach((error) => dispatch(setAlert(error.msg, "error")));
    return { success: false };
  }
};

